import React from 'react';
import '../styles/main.css';
import logo from '../assets/store-space-self-storage-logo.png';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="container">
      <div className="header">

      <img 
        src={logo} 
        alt="Store Space Self Storage Logo" 
        className="logo"
      />
      
      </div>
      {children}
    </div>
  );
};

export default Layout; 